/**
 * Centralized API path constants.
 *
 * Single source of truth for all /api/v1/ prefixes.
 * Use these instead of hardcoding "/api/v1/" across feature files.
 */
export const API = "/api/v1" as const;

export const AUTH = `${API}/auth` as const;
export const PUBLISHERS = `${API}/publishers` as const;
export const TITLES = `${API}/titles` as const;
export const NOTIFICATIONS = `${API}/notifications` as const;
export const SERVICES = `${API}/services` as const;
export const ADMIN = `${API}/admin` as const;
export const ADMIN_PUBLISHERS = `${ADMIN}/publishers` as const;
export const ADMIN_TITLES = `${ADMIN}/titles` as const;
export const ADMIN_SERVICES = `${ADMIN}/services` as const;
export const ADMIN_DOCUMENTS = `${ADMIN}/documents` as const;
export const LEGAL_DOCUMENTS = `${API}/legal` as const;
export const BILLING = `${API}/billing` as const;